/* src/app/modules/shared/components/datetime-picker/datetime-picker.component.scss */
input[bsdatepicker] {
  margin-top: 1px;
}
.mat-mdc-form-field {
  max-width: 300px;
}
/*# sourceMappingURL=datetime-picker.component.css.map */
